import { FiMoon, FiSun } from "react-icons/fi";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const label = `Switch to ${theme === "dark" ? "light" : "dark"} theme`;
  return <button type="button" onClick={toggleTheme} aria-label={label} title={label}
    className="theme-toggle flex h-10 w-10 shrink-0 items-center justify-center rounded-md border-0 bg-transparent text-current hover:opacity-75 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600">
    {theme === "dark" ? <FiSun aria-hidden="true" className="h-5 w-5" /> : <FiMoon aria-hidden="true" className="h-5 w-5" />}
  </button>;
}
